<template>
    <div class="projectAddress-box">
        <HeaderNav
            header-title="查看定位"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <!-- <span class="back iconfont" @click="handleBack">&#xe607;</span> -->
        <div class="container">
            <div class="amap-demo" id="amapDemo"></div>
            <div class="info-con">
                {{ address }}
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { HeaderNav } from '@/components/';
import { lazyAMapApiLoaderInstance } from 'vue-amap';
export default {
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            map: null,
            searchStr: '',
            address: '', // 地址
            longitude: '', // 经度
            latitude: '', // 纬度
        };
    },
    watch: {},
    computed: {},
    methods: {
        
    },
    created() {
        this.address = this.$route.params.address;
        const address = this.address;
        const longitude = this.$route.params.longitude;
        const latitude = this.$route.params.latitude;
        lazyAMapApiLoaderInstance.load().then(() => {
            let map;
            // 加入高德地图
            map = new AMap.Map('amapDemo', {
                resizeEnable: true,
                zoom: 12, // 级别
            });
            addMarker();
            // 实例化点标记
            function addMarker() {
                let marker = new AMap.Marker({
                    icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                    position: [longitude,latitude],
                    offset: new AMap.Pixel(-13, -30),
                    map: map,
                });
                // marker.setMap(map);
                map.setFitView();
            }
            openInfo();
            //在指定位置打开信息窗体
            function openInfo() {
                //构建信息窗体中显示的内容
                var info = [];
                info.push("<p class='input-item'>"+ address +"</p></div></div>");
                let infoWindow = new AMap.InfoWindow({
                    content: address,  //使用默认信息窗体框样式，显示信息内容
                    offset: new AMap.Pixel(0, -30),
                    anchor: 'top-center',
                });
                infoWindow.open(map, [longitude,latitude]);
            }
            
        });
    },
    mounted() {},
};
</script>
<style lang="stylus">
.projectAddress-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .back
        position absolute
        top 10rpx
        left 15rpx
        z-index 10000
        color #fff
    .container
        height 100%
        position relative
        .search
            position absolute
            top 10rpx
            width 100%
            padding 10rpx
            height 40rpx
            z-index 1000
            input
                border 1px solid #D7D7D7
                padding 5rpx!important
                border-radius 5rpx
                overflow hidden
                width 100%
                height 38rpx
        .amap-demo
            height 100%
        .info-con
            position absolute
            bottom 0
            width 100%
            height 50rpx
            background #fff
            padding-left 10rpx
            line-height 50rpx
        .amap-logo
            display: none!important;
        .amap-copyright {
            display: none!important;
}
</style>